import { render } from "./AlvoFC.vue?vue&type=template&id=9307bcf6&scoped=true"
import script from "./AlvoFC.vue?vue&type=script&lang=js"
export * from "./AlvoFC.vue?vue&type=script&lang=js"

import "./AlvoFC.vue?vue&type=style&index=0&id=9307bcf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9307bcf6"]])

export default __exports__